/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { TimelineList } from '../../models/timeline-list';

export interface ProcedureControllerGetTimeline$Params {
  id: number;
}

export function procedureControllerGetTimeline(http: HttpClient, rootUrl: string, params: ProcedureControllerGetTimeline$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: TimelineList;
}>> {
  const rb = new RequestBuilder(rootUrl, procedureControllerGetTimeline.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: TimelineList;
      }>;
    })
  );
}

procedureControllerGetTimeline.PATH = '/procedure/{id}/timeline';
